
import { defineComponent } from "vue";

export default defineComponent({
  name: "custom-input",
  methods: {
    moveEdit() {
      this.$router.push("/edit");
    },
  },
});
